module.exports = __webpack_public_path__ + "img/bahia_background_768.6bfee067.svg";